import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { AppyUser } from 'src/app/core/model/v2/AppyUser';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-user-impersonate-selection',
  templateUrl: './user-impersonate-selection.component.html',
  styleUrls: ['./user-impersonate-selection.component.scss']
})
export class UserImpersonateSelectionComponent implements OnInit {

  pageSize = 10;
  page = 1;
  totalRecords =0;
  displayedColumns: string[] = ['id','email','action'];
  users : AppyUser[];
  @ViewChild('userSearchInput', { static: true }) userSearchInput: ElementRef;
  
  constructor(private userService : UserService, private loaderService: WindowLoaderService) 
  { 
    this.userService.getUserDetails().subscribe
    (
      (user) => 
      {
        if(user.role != "AHIAdministrator")
        {
          window.location.href = 'home';
        }
      }
    )

  }



  ngOnInit() {    

    fromEvent(this.userSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
     if(text.length>=3){
      this.page =1;
      this.pageSize = 10;
      this.searchUser(text);
     }
      
    });
  }

  searchUser(email:string)
  {
    this.loaderService.blockWithLoader(this.userService.searchUserByEmail(email,this.page,this.pageSize))
    .subscribe
    (
      (r) => {this.users = r.result.pageItems; this.totalRecords = r.result.totalRecords;}
    )
  }

  impersonateUser(user : AppyUser)
  {
    this.userService.impersonate(user.id,'home');    
  }
  
  changeIndex(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
   
    const searchText = this.userSearchInput.nativeElement.value;
    if (searchText.length >= 3) {
      this.searchUser(searchText);
    }
  }
}
